<template>
<div id="apppnf" v-cloak>
    <h1 style="margin-top:30px;" class="text-center">Ops! Non è possibile accedere alla pagina, permesso negato</h1>
    <div class="text-center" style="margin-top:30px;">
        <b-button size="lg" variant="outline-primary" @click.stop="back()">
            &lt; Back
        </b-button>
    </div>
</div>
</template>

<script>
export default {
    name: 'apppnf',
    data: function () {
        return {};
    },
    methods: {
        back() {

            this.$router.go(-1);

        },
    },
    created: function () {
        
        
        
    }
}
</script>
